<template>
  <thead class="table-heading">
    <tr>
      <template v-for="(item, index) in header[0]">
        <th
          v-if="item.visible ?? !showMore"
          :key="index"
          class="text-center text-dark"
          :class="item.class ?? ''"
          :rowspan="item.rowspan ?? 1"
          :colspan="item.colspan ?? 1"
        >
          <div class="w-100 h-100">
            <div
              class="d-flex justify-center align-center w-100"
              style="height: 70%"
            >
              <v-tooltip v-if="item?.tooltipText" bottom>
                <template #activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon x-small>mdi-help-circle-outline</v-icon>
                    {{ item.text }}</span
                  >
                </template>
                <span>{{ item.tooltipText }}</span>
              </v-tooltip>
              <div v-else v-html="item.text" />
            </div>
            <sort-by-button
              v-if="item.isSortable"
              class="justify-center"
              :data="data"
              :column="item.value"
              :type="item.type"
              icon-up="mdi-arrow-up"
              icon-down="mdi-arrow-down"
              @sortedData="$emit('sortedData', $event)"
            />
          </div>
        </th>
      </template>

      <th :colspan="showMore ? '14' : '4'" class="pa-0">
        <div class="d-flex flex-column align-center">
          <span class="text-black font-weight-bold">
            Facturacion Neta / <span class="text-caption"> Renglonaje </span>
          </span>
          <v-checkbox
            v-model="showMore"
            class="mt-0"
            :hide-details="true"
            solo
            @change="$emit('showMore', $event)"
          >
            <template #label>
              <span class="text--darken-2 text-caption">
                Mostrar más {{ billingType == 1 ? 'trimestres' : 'meses' }}
              </span>
            </template>
          </v-checkbox>
        </div>
      </th>
    </tr>

    <tr class="mt-n10">
      <template v-if="!showMore">
        <th
          v-for="(item, index) in header[1]"
          :key="index"
          class="text-center text-dark"
          :class="item.class ?? ''"
          :rowspan="item.rowspan ?? 1"
          :colspan="item.colspan ?? 1"
        >
          <v-tooltip v-if="item?.tooltipText" bottom>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" class="mb-auto" v-on="on">
                <v-icon x-small>mdi-help-circle-outline</v-icon>
                {{ item.text }}</span
              >
            </template>
            <span>{{ item.tooltipText }}</span>
          </v-tooltip>
          <div v-else class="mb-auto" v-html="item.text" />
          <sort-by-button
            v-if="item.isSortable"
            class="w-100"
            :data="data"
            :column="item.value"
            :type="item.type"
            icon-up="mdi-arrow-up"
            icon-down="mdi-arrow-down"
            @sortedData="$emit('sortedData', $event)"
          />
        </th>
      </template>
      <template v-if="billingType == 1">
        <th
          v-for="(item, index) in headerBillingQuarters.slice(
            0,
            showMore ? 13 : 4
          )"
          :key="item.date"
          class="text-center text-dark font boder-x-none pa-0"
        >
          <a> Trimestre <br />{{ `${item.quarter}/${item.year}` }} </a>
          <sort-by-button
            class="w-100 mb-0"
            :data="data"
            :column="`history.quarterly[${index}].billing`"
            type="number"
            @sortedData="$emit('sortedData', $event)"
          />
        </th>
      </template>
      <template v-else>
        <th
          v-if="showMore"
          class="text-center text-dark font boder-x-none pa-0"
        >
          Promedio <br />
          ultimos <br />
          12 meses
          <sort-by-button
            class="w-100 mb-0"
            :data="data"
            column="AVG12Billing"
            type="number"
            @sortedData="$emit('sortedData', $event)"
          />
        </th>
        <th
          v-for="(item, index) in headerBillingMonths.slice(
            0,
            showMore ? 13 : 4
          )"
          :key="item.date"
          class="text-center text-dark font boder-x-none pa-0"
        >
          {{ item.date }} <br />
          <sort-by-button
            class="w-100 mb-0"
            :data="data"
            :column="`history.monthly[${index}].billing`"
            type="number"
            @sortedData="$emit('sortedData', $event)"
          />
        </th>
      </template>
    </tr>
  </thead>
</template>

<script>
  import service from '@/mixins/service';
  import SortByButton from '@/components/SortByButton.vue';

  export default {
    name: 'CustomerList',
    components: { SortByButton },
    mixins: [service],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
      orderBy: {
        type: Function,
        default: () => {},
      },
      sortable: {
        type: Boolean,
        default: false,
      },
      billingType: {
        type: String,
        default: '1',
      },
      data: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        headerBillingMonths: [],
        showMore: false,
        paymentType: '1',
        headerBillingQuarters: [],
      };
    },
    computed: {
      header() {
        return [
          [
            {
              text: 'Cliente',
              value: 'name',
              isSortable: true,
              type: 'string',
              class: 'boder-x-none column-fixed',
              colspan: this.showMore ? 1 : 2,
              rowspan: 2,
              visible: true,
            },
            {
              text: 'Rotulado',
              isSortable: false,
              class: 'boder-x-none pa-0',
              rowspan: 2,
            },
            {
              text: 'Antigüedad <br> del cliente <br>en <br> sistema ',
              value: 'seniorityMonths',
              isSortable: true,
              type: 'number',
              class: 'pa-0',
              rowspan: 2,
            },
            {
              text: 'PPDP',
              value: 'ppdp3',
              isSortable: true,
              type: 'number',
              tooltipText: 'Prom pond de días de pago últ 3 meses (#Docs)',
              class: 'pa-1',
              rowspan: 2,
            },
            {
              text: 'Límite de<br>crédito',
              value: 'credit.limit',
              isSortable: true,
              type: 'number',
              rowspan: 2,
            },
            {
              text: 'Crédito <br>disponible',
              value: 'credit.available',
              isSortable: true,
              type: 'number',
              class: 'pa-1',
              rowspan: 2,
            },
            {
              text: 'Pagaré',
              isSortable: false,
              rowspan: 2,
            },
            {
              text: 'Facturación',
              isSortable: false,
              colspan: 2,
              rowspan: 1,
            },
            {
              text: 'Crecimiento <br>acumulado',
              value: 'cumulativeGrowth',
              isSortable: true,
              type: 'number',
              rowspan: 2,
              class: 'pa-0',
            },
            {
              text: 'Prom. <br>compra últ.<br> 6 meses',
              rowspan: 2,
              class: 'pa-1',
              value: 'averagePurchaseLastSixMonths',
              isSortable: true,
              type: 'number',
            },
            {
              text: 'Pedidos<br> mes',
              rowspan: 2,
              class: 'pa-0',
              value: 'orders',
              isSortable: true,
              type: 'number',
            },
            {
              text: 'BackOrder',
              value: '',
              isSortable: false,
              rowspan: 2,
              class: 'pa-0',
            },
          ],
          [
            {
              text: 'PNC',
              tooltipText: 'Nuevos P/ cliente',
              value: 'billingPncPercentage',
              isSortable: true,
              type: 'number',
            },
            {
              text: 'Genética <br> N',
              value: 'billingGnPercentage',
              isSortable: true,
              type: 'number',
            },
          ],
        ];
      },
    },
    created() {
      this.headerBillingQuarters = this.getQuartersList(13, '/');
      this.headerBillingMonths = this.calcularUltimosMeses(13);
    },
  };
</script>
